import type {QueryClient} from '@tanstack/react-query';
import {resolveWpSpecialSyncCodes} from '@/pages/components/audit/adjustment/adjust/dialogs/utils/wpSpecialSyncCodes';

/**
 * Invalidate paired working-paper queries after a special-sync WP save.
 * WHY: adjustment list refresh is owned by notifyFsAdjustmentSilentRefresh / setDataSaved
 * (coalesced). Invalidating list here caused duplicate queryAdjustmentList on every save.
 */
export async function invalidateWpSpecialSyncQueries(
    queryClient: QueryClient,
    companyId: number | undefined,
    annualId: number | undefined,
    saveCode: string,
    componentName?: string,
): Promise<void> {
    if (!companyId || !annualId) {
        return;
    }
    const codes = resolveWpSpecialSyncCodes(saveCode, componentName);
    await Promise.all(codes.map((code) =>
        queryClient.invalidateQueries({
            queryKey: ['workingPaper', companyId, annualId, code],
        }),
    ));
}
